<template>
  <div>
    <stormy-dialog
      :show="show"
      title="Es ist ein Fehler aufgetreten"
      width="lg"
      height="sm"
      @hide="onClose"
    >
      <template #header>
        <div class="font-medium mx-6 my-6 bg-white text-red-600">
          {{ error.message }}
        </div>
      </template>
      <template #content>
        <dl class="space-y-1 -mx-2 text-sm">
          <div
            v-for="(value, key) in error"
            :key="key"
            class="px-4 py-1"
          >
            <dt class=" text-gray-500 uppercase text-sm mt-1">
              {{ key }}
            </dt>
            <dd
              class="mt-1 font-medium   leading-6 text-gray-900 hyphens-auto text-justify"
              lang="de"
            >
              {{ value }}
            </dd>
          </div>
        </dl>
      </template>
      <template #footer>
        <div class="flex-1 flex items-center w-full">
          <div class="flex-1 space-x-2">
            <stormy-button
              varian="default"
              icon="tabler-copy"
              @click="onCopy"
            >
              Fehlerdetails in Zwischenablage kopieren
            </stormy-button>
          </div>
          <div class="flex-none space-x-2">
            <stormy-button
              variant="primary"
              @click="onClose"
            >
              Schließen
            </stormy-button>
          </div>
        </div>
      </template>
    </stormy-dialog>
  </div>
</template>

<script setup>
import { useProp } from '@/composables/useProp.js'
import { computed } from 'vue'
import { useGlobalStore } from '@/pinia/GlobalStore'
import { storeToRefs } from 'pinia'
import { omit } from 'lodash'
import { useClipboard } from '@vueuse/core'

const globalStore = useGlobalStore()
const { axiosError } = storeToRefs(globalStore)

const props = defineProps({
  title: useProp(String, 'Löschen bestätigen'),
  message: useProp(String, 'Möchtest Du den Datensatz wirklich löschen?'),
  size: useProp(String, 'md'),
  textConfirmation: useProp(String, 'Löschen'),
  textCancel: useProp(String, 'Abbrechen'),
  variant: useProp(String, 'danger'),
  errorObject: useProp(String),
  show: useProp(Boolean)
})

const { copy, copied, isSupported } = useClipboard()

const emit = defineEmits(['cancel'])

const statusText = computed(() => {
  const statusText = error.value.status
  const statusCode = error.value.status
  return `${statusCode} ${statusText}`
})

const error = computed(() => JSON.parse(props.errorObject))

const onCopy = () => {
  copy(JSON.stringify(error.value))
}

const onClose = async () => {
  emit('cancel')
}

</script>
